<template>
  <div
    id="spinner"
    v-show="!loaded"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img :src="isamnet" width="100%" @load="onLoad" />
    <div
      class="spin-wrapper"
      :style="
        creative.offset_bottom_number
          ? `bottom:${creative.offset_bottom_number}${
              creative.offset_bottom_unit
            }`
          : ``
      "
    >
      <div class="spin-container">
        <div class="spin-main-circle">
          <a
            v-for="key in ['top', 'left', 'right', 'bottom']"
            :key="key"
            :href="creative[key].landing_page"
            target="_blank"
          >
            <img
              v-for="(image, index) in creative[key].images"
              :key="index"
              :src="image.url"
              :class="[
                'spin-circle-img',
                `spin-circle-${key}`,
                { 'spin-shake-img': image.use_shake_center },
              ]"
              :style="[
                {
                  'z-index': index * 100,
                },
                image.use_shake_center
                  ? {
                      'transform-origin': `${image.shake_center.x}% ${
                        image.shake_center.y
                      }%`,
                    }
                  : '',
              ]"
            />
          </a>
          <img
            src="https://cdn.aralego.net/rich_media/assets/spinner/spinnow.png"
            class="spin-circle-arrow"
          />
        </div>
        <a class="closebutton" @click="close()"></a>
      </div>
    </div>
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      loaded: 1,
      degree: 0,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/spinner.png";
      } else {
        isAmnet += "/spinner/bg.png";
      }
      return isAmnet;
    },
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    this.refreshImage();
    this.left = () => this.handleGesture("left");
    this.right = () => this.handleGesture("right");

    const wrapper = document.querySelector(".spin-wrapper");
    this.handleTouch(wrapper);
    // this.handleAnimate(wrapper);
  },
  mixins: [mixPreview, mixMobile],
  methods: {
    handleGesture(gesture) {
      if (this.isAnimating) return;
      gesture === "left" ? (this.degree -= 90) : (this.degree += 90);
      const maincircle = document.querySelector(".spin-main-circle");
      this.setStyle(maincircle, {
        WebkitTransform: "rotate(" + this.degree + "deg)",
        transform: "rotate(" + this.degree + "deg)",
      });
      this.refreshImage();
    },
    refreshImage() {
      var imgs = document.querySelectorAll(".spin-circle-img");
      imgs.forEach((img) => {
        img.classList.add("spin-circle-img-hide");
      });
      switch (this.degree % 360) {
        case 90:
        case -270:
          imgs = document.querySelectorAll(".spin-circle-left");
          imgs.forEach((img) => {
            img.classList.remove("spin-circle-img-hide");
          });
          break;
        case 180:
        case -180:
          imgs = document.querySelectorAll(".spin-circle-bottom");
          imgs.forEach((img) => {
            img.classList.remove("spin-circle-img-hide");
          });
          break;
        case 270:
        case -90:
          imgs = document.querySelectorAll(".spin-circle-right");
          imgs.forEach((img) => {
            img.classList.remove("spin-circle-img-hide");
          });
          break;
        case 0:
        default:
          imgs = document.querySelectorAll(".spin-circle-top");
          imgs.forEach((img) => {
            img.classList.remove("spin-circle-img-hide");
          });
          break;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.spin-wrapper
  width: 100%
  height: 190px
  position: fixed
  bottom: 0px
  overflow: hidden
  .spin-main-circle
    width: 350px
    height: 350px
    transition: transform 0.8s
    background: url('https://cdn.aralego.net/rich_media/assets/spinner/4pies.png')
    background-size: 450px
    background-position: center
    border-radius: 200px
    position: relative
    margin-left: auto
    margin-right: auto
    top: 30px
    left: 0
    right: 0
    a
      display: -webkit-box
      display: -moz-box
      display: -ms-flexbox
      display: -webkit-flex
      display: flex
      justify-content: center
      height: 100%
      width: 100%
    img
      cursor: pointer
      position: absolute
      width: 350px
      top: 0px
      left: 0px

.spin-circle-img-hide
  display: none

.spin-circle-arrow
  animation-name: rotate-s-loader
  animation-iteration-count: infinite
  animation-duration: 2s
  animation-timing-function: linear
  pointer-events: none
  z-index: 999

.spin-shake-img
  -webkit-transition: all 1.5s ease
  animation: shake-animation 1.5s linear infinite
  -webkit-animation: shake-animation 1.5s linear infinite

.spin-shake-img2
  -webkit-transition: all 1.5s ease
  animation: shake-animation2 1.5s linear infinite
  -webkit-animation: shake-animation2 1.5s linear infinite

.closebutton
  cursor: pointer
  position: absolute
  display: block
  width: 32px
  height: 32px
  background-color: white
  background-position: 0 0
  background-image: url('https://cdn.aralego.net/rich_media/assets/close_btn.png')
  background-size: contain
  z-index: 50000
  top: 15px
  right: 5px
  border-radius: 16px

@include keyframes(rotate-s-loader)
  0%
    transform: rotate(0)
  100%
    transform: rotate(-360deg)

@include keyframes(shake-animation)
  0%
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)
  50%
    -webkit-transform: rotate(8deg)
    transform: rotate(8deg)
  100%
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)

@include keyframes(shake-animation2)
  0%
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)
  50%
    -webkit-transform: rotate(-8deg)
    transform: rotate(-8deg)
  100%
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)
</style>
